module.exports = __webpack_public_path__ + "static/media/marketoPlugHeader2x.1811faf8.png";